(function() {

  // artistsごとの出し分け
  const keywordMap = {
    // imp.
    'imp': 'imp',
    'arata_sato': 'arata_sato',
    'shunsuke_motoi': 'shunsuke_motoi',
    'takuya_kageyama': 'takuya_kageyama',
    'minato_matsui': 'minato_matsui',
    'taiga_tsubaki': 'taiga_tsubaki',
    'yuki_yokohara': 'yuki_yokohara',
    'taiga_suzuki': 'taiga_suzuki',
    // number_i
    'sho_hirano': 'sho_hirano',
    'yuta_jinguji': 'yuta_jinguji',
    'yuta_kishi': 'yuta_kishi',
    'number_i': 'number_i',
    // class seven
    'classseven': 'classseven',
    'ritsuki_ohigashi': 'ritsuki_ohigashi',
    'shuu_takano': 'shuu_takano',
    'ren_takada': 'ren_takada',
    'taikai_kondo': 'taikai_kondo',
    'taiga_yokota': 'taiga_yokota',
    'keito_hoshi': 'keito_hoshi',
    'ren_nakazawa': 'ren_nakazawa',
    // wink_first
    'winkfirst': 'winkfirst',
    'taiga_shimada': 'taiga_shimada',
    'shoma_fujishiro': 'shoma_fujishiro',
    'ko_matsuzaki': 'ko_matsuzaki',
    'ruki_kawada': 'ruki_kawada',
    'yushi_kosukegawa': 'yushi_kosukegawa',
  };
  
  const defaultKeyword = '-';
  
  const currentURL = document.location.href;
  const keyword = Object.keys(keywordMap).find(key => currentURL.includes(key)) || defaultKeyword;
  
  const labels = document.querySelectorAll('.custom-grid-item a');
  labels.forEach(label => {
    const href = label.getAttribute('href');
    if (href.includes(keyword)) {
      label.classList.add('is-active');
    } else {
      label.classList.remove('is-active');
    }
  });
}());
